export default __webpack_public_path__ + "static/media/mainPhoto.f5bbf65a.png";